import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Loader2, Eye, Mail } from "lucide-react";

const AdminContent = ({ onAuthError }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  const [detail, setDetail] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => adminApi.get(`/admin/content?q=${encodeURIComponent(q)}`).then((r) => setRows(r.data)).catch(onAuthError);
  useEffect(() => { load(); }, []);

  const view = async (genId) => {
    setOpen(true); setDetail(null);
    try { const { data } = await adminApi.get(`/admin/content/${genId}`); setDetail(data); }
    catch (e) { onAuthError(e); }
  };

  return (
    <div data-testid="admin-content">
      <div className="flex gap-2 mb-4">
        <Input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search by role or email…" className="bg-white border-slate-300 text-slate-900 max-w-sm" data-testid="admin-content-search" />
        <Button onClick={load} className="bg-sky-600 hover:bg-sky-500 text-white">Search</Button>
      </div>
      {!rows ? <div className="flex justify-center py-20 text-slate-500"><Loader2 className="w-5 h-5 animate-spin" /></div> : (
        <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-24px_rgba(15,23,42,0.22)] overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] font-mono uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <th className="px-4 py-3">Target Role</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Cover Letter</th><th className="px-4 py-3 text-right">View</th>
            </tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan="4" className="px-4 py-8 text-center text-slate-500">No generated resumes.</td></tr>}
              {rows.map((r) => (
                <tr key={r.gen_id} className="border-b border-slate-200" data-testid={`admin-content-row-${r.gen_id}`}>
                  <td className="px-4 py-3 text-slate-800">{r.role_title}</td>
                  <td className="px-4 py-3 text-slate-500">{r.user_email}</td>
                  <td className="px-4 py-3">{r.has_cover_letter ? <Mail className="w-4 h-4 text-emerald-600" /> : <span className="text-slate-400">—</span>}</td>
                  <td className="px-4 py-3 text-right"><Button size="sm" variant="outline" onClick={() => view(r.gen_id)} className="border-slate-300 text-slate-700 h-8" data-testid={`admin-content-view-${r.gen_id}`}><Eye className="w-3.5 h-3.5" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white border-slate-200 text-slate-900 max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{detail ? detail.role_title : "Loading…"}</DialogTitle></DialogHeader>
          {!detail ? <div className="flex justify-center py-10 text-slate-500"><Loader2 className="w-5 h-5 animate-spin" /></div> : (
            <div className="space-y-4 text-sm" data-testid="admin-content-detail">
              <p className="text-xs text-slate-500">By {detail.user?.email || "—"}</p>
              <div><p className="font-bold text-slate-800">{detail.resume?.name} — {detail.resume?.target_title}</p><p className="text-slate-500 mt-1">{detail.resume?.summary}</p></div>
              {detail.resume?.skills?.length > 0 && <p className="text-slate-700"><span className="text-slate-500">Skills:</span> {detail.resume.skills.join(", ")}</p>}
              {detail.cover_letter?.full_text && (
                <div className="border-t border-slate-200 pt-3">
                  <p className="font-mono text-xs uppercase tracking-wider text-slate-500 mb-2">Cover Letter</p>
                  <pre className="whitespace-pre-wrap font-sans text-slate-700 text-sm">{detail.cover_letter.full_text}</pre>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminContent;
